import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  Lightbulb, 
  GraduationCap, 
  Building2, 
  TrendingUp, 
  Users, 
  Target, 
  Rocket,
  Globe,
  CheckCircle2,
  ArrowRight,
  Sparkles,
  Heart,
  Handshake,
  Medal,
  Zap,
  Calendar,
  MapPin
} from 'lucide-react';
// these 

const AboutAID = () => {
  const [hoveredPillarId, setHoveredPillarId] = useState(null);
  const [hoveredValueId, setHoveredValueId] = useState(null);

  const pillars = [
    {
      id: 1,
      title: 'Company',
      description: 'Partnering with leading companies to drive industrial growth and create employment opportunities.',
      Icon: Building2,
      color: '#3B82F6',
      stats: 'Join Us',
      link: '/login'
    },
    {
      id: 2,
      title: 'Association',
      description: 'Collaborating with industry associations to strengthen business networks and policy advocacy.',
      Icon: Handshake,
      color: '#10B981',
      stats: 'Join Us',
      link: '/login'
    },
    {
      id: 3,
      title: 'Academia',
      description: 'Working with academic institutions to bridge the gap between education and industry needs.',
      Icon: GraduationCap,
      color: '#8B5CF6',
      stats: 'Join Us',
      link: '/login'
    },
    {
      id: 4,
      title: 'Investor',
      description: 'Connecting entrepreneurs with investors to fuel innovation and business expansion.',
      Icon: TrendingUp,
      color: '#F59E0B',
      stats: 'Join Us',
      link: '/login'
    },
    {
      id: 5,
      title: 'Startup',
      description: 'Supporting startups with resources, mentorship, and opportunities for sustainable growth.',
      Icon: Rocket,
      color: '#EC4899',
      stats: 'Join Us',
      link: '/login'
    },
    {
      id: 6,
      title: 'Incubator',
      description: 'Facilitating incubation centers that nurture early-stage ventures and innovative ideas.',
      Icon: Lightbulb,
      color: '#06B6D4',
      stats: 'Join Us',
      link: '/login'
    }
  ];

  const timeline = [
    {
      year: '2020',
      title: 'Foundation',
      description: 'AID was established with a vision to transform India through comprehensive development initiatives.',
      icon: Rocket,
      color: '#8B5CF6'
    },
    {
      year: '2021',
      title: 'First Projects',
      description: 'Launched pilot programs in technology adoption and educational outreach.',
      icon: Sparkles,
      color: '#3B82F6'
    },
    {
      year: '2022',
      title: 'Expansion',
      description: 'Extended operations to multiple districts with focus on sustainable infrastructure.',
      icon: TrendingUp,
      color: '#10B981'
    },
    {
      year: '2023',
      title: 'Innovation Hub',
      description: 'Established innovation centers to foster entrepreneurship and technological advancement.',
      icon: Zap,
      color: '#F59E0B'
    }
  ];



  const impactStats = [
    { number: "40+", label: "Projects Completed", Icon: Target },
    { number: "2M+", label: "Lives Impacted", Icon: Users },
    { number: "50+", label: "Districts Reached", Icon: Globe },
    { number: "100+", label: "Partners", Icon: Handshake }
  ];

  return (
    <div style={{ fontFamily: '"Rubik", sans-serif', backgroundColor: "#fff", minHeight: "100vh", color: "#333", marginBottom: "60px" }}>
      <style>{`
        @media (max-width: 900px) {
          .about-hero-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
            padding: 50px 20px !important;
          }
          .about-hero-heading {
            font-size: 28px !important;
          }
          .about-pillars-grid {
            grid-template-columns: 1fr !important;
          }
          .about-section-pad {
            padding: 50px 20px !important;
          }
          .about-section-title {
            font-size: 28px !important;
          }
          .about-section-desc {
            font-size: 15px !important;
          }
        }
        @media (max-width: 480px) {
          .about-hero-image-grid {
            grid-template-columns: 1fr !important;
          }
          .about-hero-image-grid > div:first-child {
            grid-column: 1 / 2 !important;
          }
        }
      `}</style>

      {/* HERO SECTION - Split Design */}
      <div style={{
        position: "relative",
        overflow: "hidden",
        background: "linear-gradient(135deg, #fafbfc 0%, #f0f0f5 100%)"
      }}>
        <div className="about-hero-grid" style={{
          maxWidth: "1400px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "1.1fr 1fr",
          gap: "60px",
          alignItems: "center",
          padding: "80px 40px"
        }}>
          {/* Left Content */}
          <div style={{ position: "relative", zIndex: 2 }}>
            {/* Badge */}
            <div style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              padding: "12px 24px",
              background: "linear-gradient(135deg, #470172 0%, #764ba2 100%)",
              borderRadius: "50px",
              marginBottom: "30px",
              boxShadow: "0 4px 20px rgba(71, 1, 114, 0.25)"
            }}>
              <Rocket size={20} color="#fff" />
              <span style={{ fontSize: "15px", fontWeight: "600", color: "#fff", letterSpacing: "0.5px" }}>
                Transforming India
              </span>
            </div>

            {/* Main Heading */}
            <h1 className="about-hero-heading" style={{
              fontSize: "36px",
              fontWeight: "700", 
              lineHeight: "1.1", 
              marginBottom: "30px",
              letterSpacing: "-1.5px"
            }}>
              About
              <br />
              <span style={{ 
                background: "#3C007A",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text"
              }}>
                The Association for Industrial Development
              </span>
            </h1>

            {/* Description */}
            <p style={{ 
              fontSize: "18px", 
              color: "#4a5568", 
              lineHeight: "1.8",
              marginBottom: "40px",
              maxWidth: "580px"
            }}>
              With a focus on innovation and collaboration, AID works to empower industries and unlock Vidarbha’s economic potential, driving inclusive growth through forward-looking policies, infrastructure development, and industry-led initiatives that create employment and economic resilience.
            </p>

            {/* CTA Buttons */}
            {/* <div style={{ display: "flex", gap: "15px", marginBottom: "50px" }}>
              <button style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                padding: "14px 32px",
                background: "linear-gradient(135deg, #470172 0%, #764ba2 100%)",
                color: "#fff",
                border: "none",
                borderRadius: "12px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                boxShadow: "0 4px 15px rgba(71, 1, 114, 0.3)",
                transition: "all 0.3s ease"
              }}>
                Get Involved
                <ArrowRight size={18} />
              </button>
              <button style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                padding: "14px 32px",
                background: "#fff",
                color: "#470172",
                border: "2px solid #470172",
                borderRadius: "12px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.3s ease"
              }}>
                Learn More
              </button>
            </div> */}

            {/* Quick Stats */}
            <div style={{ 
              display: "flex", 
              gap: "40px",
              borderTop: "2px solid #e5e7eb",
              paddingTop: "30px"
            }}>
            </div>
          </div>

          {/* Right Side - Image Grid */}
          <div style={{ position: "relative", zIndex: 1 }}>
            <div className="about-hero-image-grid" style={{
              position: "relative",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "20px"
            }}>
              {/* Main Large Image */}
              <div style={{
                gridColumn: "1 / 3",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 20px 60px rgba(71, 1, 114, 0.2)",
                border: "4px solid #fff"
              }}>
                <img 
                  src="img/about/1.webp" 
                  alt="Team collaboration"
                  style={{
                    width: "100%",
                    height: "350px",
                    objectFit: "cover",
                    display: "block"
                  }}
                />
              </div>

              {/* Small Image 1 */}
              <div style={{
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                border: "3px solid #fff"
              }}>
                <img 
                  src="img/about/3.webp" 
                  alt="Professional work"
                  style={{
                    width: "100%",
                    height: "200px",
                    objectFit: "cover",
                    display: "block"
                  }}
                />
              </div>

              {/* Small Image 2 */}
              <div style={{
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                border: "3px solid #fff"
              }}>
                <img 
                  src="img/about/2.jpg" 
                  alt="Innovation"
                  style={{
                    width: "100%",
                    height: "200px",
                    objectFit: "cover",
                    display: "block"
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Impact Statistics Bar */}
        {/* <div style={{
          maxWidth: "1200px",
          margin: "0 auto 0",
          padding: "40px 50px",
          background: "linear-gradient(135deg, #470172 0%, #764ba2 100%)",
          borderRadius: "20px 20px 0 0",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: "40px",
          boxShadow: "0 -10px 40px rgba(71, 1, 114, 0.15)"
        }}>
          {impactStats.map((stat, index) => {
            const Icon = stat.Icon;
            return (
              <div key={index} style={{ textAlign: "center", position: "relative" }}>
                {index !== 0 && (
                  <div style={{
                    position: "absolute",
                    left: 0,
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "1px",
                    height: "70%",
                    background: "rgba(255, 255, 255, 0.2)"
                  }} />
                )}
                <Icon size={32} color="#fff" style={{ margin: "0 auto 12px" }} />
                <div style={{ fontSize: "36px", fontWeight: "700", color: "#fff", marginBottom: "8px" }}>
                  {stat.number}
                </div>
                <div style={{ fontSize: "15px", color: "#f0e6f6", fontWeight: "500", letterSpacing: "0.3px" }}>
                  {stat.label}
                </div>
              </div>
            );
          })}
        </div> */}
      </div>

      {/* CORE PILLARS SECTION */}
      <div className="about-section-pad" style={{ padding: "100px 40px", backgroundColor: "#fafbfc" }}>
        <div style={{ maxWidth: "1300px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "70px" }}>
            <h2 className="about-section-title" style={{ fontSize: "48px", fontWeight: "700", marginBottom: "20px", color: "#1a202c", letterSpacing: "-1px" }}>
              Our Stakeholders
            </h2>
            <p className="about-section-desc" style={{ fontSize: "19px", color: "#4a5568", maxWidth: "700px", margin: "0 auto", lineHeight: "1.7" }}>
              Building a robust ecosystem by connecting diverse stakeholders for collective growth and innovation
            </p>
          </div>

          <div className="about-pillars-grid" style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "30px"
          }}>
            {pillars.map((pillar) => {
              const Icon = pillar.Icon;
              const isHovered = hoveredPillarId === pillar.id;
              
              return (
                <div
                  key={pillar.id}
                  onMouseEnter={() => setHoveredPillarId(pillar.id)}
                  onMouseLeave={() => setHoveredPillarId(null)}
                  style={{
                    position: "relative",
                    background: isHovered 
                      ? `linear-gradient(135deg, ${pillar.color}15 0%, ${pillar.color}05 100%)`
                      : "#fff",
                    borderRadius: "24px",
                    padding: "40px 30px",
                    boxShadow: isHovered 
                      ? "0 25px 60px rgba(0,0,0,0.12)"
                      : "0 10px 30px rgba(0,0,0,0.06)",
                    border: isHovered 
                      ? `3px solid ${pillar.color}40`
                      : "3px solid transparent",
                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                    transform: isHovered ? "translateY(-8px)" : "translateY(0)",
                    cursor: "pointer",
                    overflow: "hidden"
                  }}
                >
                  {/* Decorative Corner Element */}
                  <div style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    width: "100px",
                    height: "100px",
                    background: `linear-gradient(135deg, ${pillar.color}20 0%, transparent 100%)`,
                    borderRadius: "0 24px 0 100%",
                    opacity: isHovered ? 1 : 0.5,
                    transition: "opacity 0.4s ease"
                  }} />

                  {/* Icon */}
                  <div style={{
                    width: "75px",
                    height: "75px",
                    background: isHovered 
                      ? `linear-gradient(135deg, ${pillar.color} 0%, ${pillar.color}dd 100%)`
                      : `${pillar.color}15`,
                    borderRadius: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "24px",
                    transition: "all 0.4s ease",
                    transform: isHovered ? "scale(1.1) rotate(5deg)" : "scale(1) rotate(0deg)",
                    boxShadow: isHovered ? `0 10px 30px ${pillar.color}40` : "none"
                  }}>
                    <Icon 
                      size={38} 
                      color={isHovered ? "#fff" : pillar.color}
                      strokeWidth={2.5}
                    />
                  </div>

                  {/* Content */}
                  <h3 style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "#1a202c",
                    marginBottom: "14px",
                    lineHeight: "1.3"
                  }}>
                    {pillar.title}
                  </h3>

                  <p style={{
                    fontSize: "15px",
                    color: "#4a5568",
                    lineHeight: "1.7",
                    marginBottom: "20px"
                  }}>
                    {pillar.description}
                  </p>

                  {/* Stats Badge */}
                  <Link to={pillar.link} style={{ textDecoration: "none" }}>
                    <div style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "10px 18px",
                      background: isHovered ? "#fff" : `${pillar.color}10`,
                      borderRadius: "30px",
                      border: isHovered ? `2px solid ${pillar.color}` : "2px solid transparent",
                      transition: "all 0.3s ease"
                    }}>
                      <CheckCircle2 size={18} color={pillar.color} />
                      <span style={{ 
                        fontSize: "14px", 
                        fontWeight: "600", 
                        color: pillar.color 
                      }}>
                        {pillar.stats}
                      </span>
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Image Gallery Section */}
      <div className="about-section-pad" style={{ padding: "80px 20px", backgroundColor: "#fff" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 className="about-section-title" style={{ fontSize: "46px", fontWeight: "600", marginBottom: "24px", color: "#000000", letterSpacing: "-0.5px" }}>
               Gallery
            </h2>
            <p className="about-section-desc" style={{ maxWidth: "850px", margin: "0 auto", color: "#666", lineHeight: "1.8", fontSize: "18px", fontWeight: "400" }}>
              Capturing moments of transformation and community engagement across India.
            </p>
          </div>

          {/* Images Grid */}
          <div style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))", 
            gap: "30px" 
          }}>
            {[
              {
                id: 1,
                url: "img/about/g1.JPG",
                caption: "Community Development Program",
                alt: "AID Community Engagement"
              },
              {
                id: 2,
                url: "img/about/g2.JPG",
                caption: "Technology Training Workshop",
                alt: "Training Session"
              },
              {
                id: 3,
                url: "img/about/g3.JPG",
                caption: "Innovation Hub Launch",
                alt: "Innovation Initiative"
              },
              {
                id: 4,
                url: "img/about/g4.JPG",
                caption: "Team Collaboration Initiative",
                alt: "Team Program"
              },
              {
                id: 5,
                url: "img/about/g5.JPG",
                caption: "Infrastructure Development",
                alt: "Infrastructure Project"
              },
              {
                id: 6,
                url: "img/about/g6.jpeg",
                caption: "Educational Outreach",
                alt: "Education Program"
              }
            ].map((image) => (
              <div
                key={image.id}
                style={{
                  position: "relative",
                  backgroundColor: "#fff",
                  borderRadius: "16px",
                  overflow: "hidden",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  border: "1px solid #eee"
                }}
              >
                <div style={{ height: "280px", position: "relative", overflow: "hidden" }}>
                  <img
                    src={image.url}
                    alt={image.alt}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover"
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutAID;